import React from "react"

import HotTable from "../utils/hot-table";

export default class PPIRevenues extends React.Component {
	render() {

		return (
			<div className="revenues-container">
				<HotTable
					root="revenues"
					headers={false}
					data={this.props.data}
					ppi={this.props.ppi}
					tableDefinition={this.props.tableDefinition}
					onCustomAction={this.props.onCustomAction}
					onChange={this.props.onChange}
					previousYear={this.props.previousYear}
					currentUserType = {this.props.currentUserType}
				/>
				{ this.props.consulted
					? null
					:<div className="revenues-actions">
						<button onClick={this._handleClick.bind(this)} title="Ajouter une recette"><i className="fa fa-plus" /></button>
					</div>
				}
			</div>
		)
	}

	_handleClick(e) {
		this.props.onCustomAction("new_revenue")
	}
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/revenues/table-component.js